import moment from "moment";

/**
 * The recent-chats list, in the buckets a reader scans it by.
 *
 * Every row used to say "11 days ago", which tells two chats from the same week apart by nothing
 * at all. Rows now sit under Today / Previous 7 days / Older, and each carries the one date that
 * separates it within its bucket: the time for today, the weekday for this week, the date
 * before that. The exact moment rides along for a hover.
 *
 * Pinned chats come first, in a bucket of their own, whatever their date.
 */

export const THREAD_GROUPS = {
    pinned: "Pinned",
    today: "Today",
    week: "Previous 7 days",
    older: "Older",
};

/** The short date a row shows, and the exact one behind it. `now` is injectable for tests. */
export const threadMeta = (value, now = moment()) => {
    if (!value) return { label: "", exact: "" };
    const at = moment(value);
    if (!at.isValid()) return { label: "", exact: "" };
    const exact = at.format("MMM D, YYYY h:mm A");
    if (at.isSame(now, "day")) return { label: at.format("h:mm A"), exact };
    if (at.isAfter(moment(now).startOf("day").subtract(7, "days"))) return { label: at.format("ddd"), exact };
    if (at.isSame(now, "year")) return { label: at.format("MMM D"), exact };
    return { label: at.format("MMM D, YYYY"), exact };
};

const bucketOf = (thread, now) => {
    if (thread.pinned) return "pinned";
    const at = moment(thread.at);
    if (!thread.at || !at.isValid()) return "older";
    if (at.isSame(now, "day")) return "today";
    if (at.isAfter(moment(now).startOf("day").subtract(7, "days"))) return "week";
    return "older";
};

/**
 * Rows into their buckets, in bucket order, empty buckets dropped. Rows keep the order they
 * arrived in, which is the server's (newest first) -- this groups, it does not re-sort.
 */
export const groupThreads = (threads = [], now = moment()) => {
    const buckets = { pinned: [], today: [], week: [], older: [] };
    threads.forEach((thread) => buckets[bucketOf(thread, now)].push(thread));
    return Object.keys(THREAD_GROUPS)
        .filter((key) => buckets[key].length)
        .map((key) => ({ key, label: THREAD_GROUPS[key], threads: buckets[key] }));
};
